export default __webpack_public_path__ + "static/media/which-rubbish.a543081d.svg";